export default {
  SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL,
  SUPABASE_CLIENT_KEY: import.meta.env.VITE_SUPABASE_CLIENT_KEY,
  DEV_API: import.meta.env.VITE_DEV_API,
  PROD_API: import.meta.env.VITE_PROD_API,
  MODE: import.meta.env.MODE,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
};
